
import moment from 'moment';
import React from 'react';
import SVG from "react-inlinesvg";
import { useHistory } from 'react-router-dom';
import { toAbsoluteUrl } from "../../../../../_helpers";
import { apiCalll } from "../../../../../_helpers/apiHelpers";
import { ConvertToDateCurrentTimeZoneDateTime, ConvertToDateCurrentTimeZoneDateTime24Hour, getFromatdate } from '../../../../../_helpers/GlobalHelpers';

const Message = (props) => {
    const history = useHistory();

    return (
        <>
            <div className={`d-flex align-items-top mb-6 ${props.index === 0 ? "pt-4" : ""}`} onClick={() => {
                apiCalll({
                    method: "PUT",
                    link: `/Notifications/MarkAsRead?id=${props.id}`,
                }).then((dataResult) => {
                    props.getNotificqtions()
                });
                if (props.link !== null && props.link !== "" && props.link !== undefined) {
                    history.push(props.link);
                }
            }}>
                <div className="symbol symbol-30 symbol-light-primary mr-5">
                    <span className="symbol-label">
                        <SVG
                            src={toAbsoluteUrl(props.icon)}
                            className="svg-icon-md svg-icon-primary"
                        ></SVG>
                    </span>
                    {props.isRead !== true ? <i className="symbol-badge bg-danger"></i> : ""}

                </div>
                <div className="d-flex flex-column font-weight-bold text-left" style={{ width: "100%" }}>
                    <a
                        href={() => false}
                        className="text-dark text-hover-primary mb-1 font-size-lg"
                    >
                        {props.title}
                    </a>
                    <span className="text-muted text-left" dangerouslySetInnerHTML={{
                        __html:
                            props.message
                        ,
                    }} >
                        {/* {props.message} */}
                    </span>
                    <span className={`text-danger text-right`}>
                        {props.is12HourFormat ? ConvertToDateCurrentTimeZoneDateTime(props.date) : ConvertToDateCurrentTimeZoneDateTime24Hour(props.date)}

                    </span>

                </div>
            </div>
            <div className="separator separator-solid mb-6" />
        </>
    )
};

export default Message;